// Module
var code = "<select class=\"form-control input-sm\" ng-model=\"vm.model\" ng-options=\"event.value as event.name | translate for event in vm.events\" ng-disabled=\"vm.isDisabled\"> </select>";
// Exports
module.exports = code;